/**
 * Throws a runtime error and a type error if the value is not a `never` type.
 *
 * This is useful for exhaustive switch checks to ensure that all
 * possible values are handled.
 *
 * @example
 * ```tsx
 * enum Color {
 *   RED = 'red',
 *   GREEN = 'green',
 *   BLUE = 'blue',
 * }
 *
 * switch (color) {
 *   case Color.RED:
 *     // code...
 *     break;
 *   case Color.GREEN:
 *     // code...
 *     break;
 *   default:
 *     // Typescript will throw an error here because Color.BLUE is not handled.
 *     // This will also throw a runtime error.
 *     assertUnreachableValue(color);
 * }
 * ```
 */
export function assertUnreachableValue(value) {
    throw new Error(value);
}
/**
 * Throws a type error if the value is not a `never` type.
 *
 * This is useful for exhaustive switch checks to ensure that all
 * possible values are handled.
 *
 * @example
 * ```tsx
 * enum Color {
 *   RED = 'red',
 *   GREEN = 'green',
 *   BLUE = 'blue',
 * }
 *
 * switch (color) {
 *   case Color.RED:
 *     // code...
 *     break;
 *   case Color.GREEN:
 *     // code...
 *     break;
 *   default:
 *     // Typescript will throw an error here because Color.BLUE is not handled.
 *     assertNever(color);
 * }
 * ```
 */
export function assertNever(_value) { }
//# sourceMappingURL=unreachableValue.js.map